import React from 'react';
import moment from 'moment';

export class TimeElapsed extends React.Component {
    componentDidMount() {
        // no need to setState, and handle nextProps
        this.interval = setInterval(this.forceUpdate.bind(this), 30 * 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    render() {
        return <span>{moment(this.props.date).fromNow()}</span>;
    }
}



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/TimeElapsed.js
 **/